import * as React from "react";
import { Path } from "react-native-svg";
import { Icon, IIconProps } from "native-base";

export const WriteNotes = (props: IIconProps & { isOutline?: boolean }) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <Path
      d="M20.6801 16.5001C20.4601 17.8701 19.646 19.7002 16.5101 20.6801C13.0612 21.1723 9.55503 21.098 6.13008 20.4601C5.50844 20.2949 4.9415 19.9683 4.48668 19.5135C4.03185 19.0587 3.70529 18.4917 3.54008 17.8701C2.81997 13.9899 2.81997 10.0103 3.54008 6.13008C3.70529 5.50844 4.03185 4.9415 4.48668 4.48668C4.9415 4.03185 5.50844 3.70529 6.13008 3.54008C10.0103 2.81997 13.9899 2.81997 17.8701 3.54008C18.4917 3.70529 19.0587 4.03185 19.5135 4.48668C19.9683 4.9415 20.2949 5.50844 20.4601 6.13008C20.5116 6.40705 20.5577 6.69815 20.5988 7"
      stroke="currentColor"
      fill="transparent"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <Path d="M8 12H11H8Z" fill="currentColor" />
    <Path
      d="M8 12H11"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-miterlimit="10"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <Path
      d="M8 8.08845C9.42235 8.00017 10.7662 8.00017 12.1984 8.00017C12.5319 8.00017 12.8654 8.00017 13.1205 8.00017"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-miterlimit="10"
      fill="transparent"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <Path
      d="M17.5852 11.0603C18.2188 11.7105 18.8775 12.3608 19.5194 12.9944C18.8858 12.3692 18.2188 11.7105 17.5852 11.0603ZM18.7274 9.39288C17.2017 11.0603 15.3176 12.9027 13.6503 14.4951C13.3961 14.734 13.2289 15.0508 13.1751 15.3955C13.0767 16.117 13.0182 16.8434 13 17.5714C13.7254 17.5507 14.449 17.4894 15.1676 17.388C15.5128 17.3416 15.8311 17.1765 16.0679 16.9211C17.6603 15.2537 19.5527 13.3696 21.1701 11.8439C21.3153 11.7108 21.4267 11.5451 21.4952 11.3604C21.5635 11.1739 21.5863 10.9739 21.5619 10.7768C21.5334 10.5633 21.4656 10.357 21.3618 10.1682C21.2561 9.96407 21.1181 9.77828 20.9533 9.61798C20.788 9.45304 20.5999 9.31267 20.3947 9.20113C20.2087 9.09964 20.0049 9.03457 19.7945 9.00939C19.599 8.98538 19.4006 9.00758 19.2153 9.07418C19.03 9.14079 18.8629 9.24994 18.7274 9.39288V9.39288Z"
      stroke="currentColor"
      fill="transparent"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </Icon>
);

export default WriteNotes;
